import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=f4930902&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=ts"
export * from "./SubHeader.vue?vue&type=script&lang=ts"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=f4930902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4930902",
  null
  
)

export default component.exports